import { Link, useRouterState } from "@tanstack/react-router";
import { Phone } from "lucide-react";

import { FooterPlaceLinks } from "@/components/site/FooterPlaceLinks";
import { Logo } from "@/components/site/Logo";
import { enPathForNl } from "@/lib/i18n-urls";
import { trackPhoneClick } from "@/lib/tracking";



const QUICK_LINKS = [
  { to: "/taxi", label: "Werkgebied" },
  { to: "/boeken", label: "Taxi boeken" },
  { to: "/prijzen", label: "Prijzen" },
  { to: "/luchthaventaxi", label: "Luchthavenvervoer" },
  { to: "/contact", label: "Contact" },
  { to: "/klant/login", label: "Mijn ritten" },
] as const;

const DRIVER_LINKS = [
  { to: "/chauffeur", label: "Chauffeur worden" },
  { to: "/chauffeur/login", label: "Chauffeurs inloggen" },
] as const;

const BUSINESS_LINKS = [
  { to: "/b2b", label: "Zakelijke partners" },
  { to: "/partner/login", label: "Partner inloggen" },
] as const;

const SERVICE_LINKS = [
  { to: "/over-ons", label: "Over ons" },
  { to: "/journal", label: "Reisjournal" },
  { to: "/faq", label: "Veelgestelde vragen" },
  { to: "/voorwaarden", label: "Voorwaarden" },
  { to: "/privacy", label: "Privacy & cookies" },
  { to: "/alle-paginas", label: "Alle pagina's" },
] as const;

export function Footer() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const en = enPathForNl(pathname) ?? "/en";

  return (

    <footer className="mt-20 border-t border-border bg-muted/40">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
          <div>
            <Link to="/" className="inline-flex items-center">
              <Logo />
            </Link>
            <p className="mt-3 text-sm text-muted-foreground">
              Vaste prijzen, vooraf bekend. Luchthavenvervoer en stadsritten door heel Nederland.
            </p>
            <a
              href="tel:+31850607086"
              onClick={() => trackPhoneClick("footer")}
              className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:underline"
            >
              <Phone className="size-4" /> 085 060 7086
            </a>
            <p className="mt-3 text-sm">
              <a href={en} hrefLang="en" className="text-muted-foreground hover:text-primary">
                English version
              </a>
            </p>
          </div>


          <div>
            <div className="text-sm font-semibold uppercase tracking-wide text-foreground">
              Snel naar
            </div>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              {QUICK_LINKS.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="hover:text-primary">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-sm font-semibold uppercase tracking-wide text-foreground">
              Voor chauffeurs
            </div>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              {DRIVER_LINKS.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="hover:text-primary">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-sm font-semibold uppercase tracking-wide text-foreground">
              Zakelijk
            </div>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              {BUSINESS_LINKS.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="hover:text-primary">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-sm font-semibold uppercase tracking-wide text-foreground">
              Service
            </div>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              {SERVICE_LINKS.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="hover:text-primary">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <FooterPlaceLinks locale="nl" />

      <div className="border-t border-border py-5 text-center text-xs text-muted-foreground">
        <p>
          © {new Date().getFullYear()} Taxiritje.nl — taxivervoer met vaste prijzen.{" "}
          <Link to="/contact" className="underline underline-offset-2 hover:text-foreground">
            Bedrijfsgegevens
          </Link>
        </p>
      </div>

    </footer>
  );
}

